import * as types from '../actions/actionTypes';
import { assign } from 'lodash';
const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)
const ROOT_URL = (local || develop)
  ? 'https://myphoto-api-develop.appspot.com'
  : (staging)
    ? 'https://myphoto-api-staging.appspot.com'
    : 'https://mp-cloud-api.appspot.com'

const initialState = {
  draw: false,
  results: [
    {
      id: '',
      salesChannelId: 0,
      status: '',
      sourceId: '',
      cartId: '',
      alert: "",
      dropship: true,
      createDate: '',
      discount: {
        promoCode: '',
        discountName: '',
        discountType: '',
      },
      customer: {
        id: '',
        sourceId: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
      },
      notes: {
        gift: '',
        order: [],
      },
      events: [],
      billingAddress: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zipCode: '',
        country: '',
      },
      shipping: [
        {
          id: 0,
          method: '',
          address: {
            name: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zipCode: '',
            country: '',
            phone: '',
            isBusiness: false,
          },
        },
      ],
      amounts: {
        merchandise: 0,
        tax: 0,
        shipping: 0,
        handling: 0,
        discount: 0,
        total: 0,
        currency: 'USD',
      },
      items: [
        {
          id: 0,
          itemId: 0,
          sourceId: 0,
          status: '',
          fulfillmentSku: '',
          sku: '',
          photoPersonalization: {
            edits: {},
            personalized: true,
            projectId: '',
            printReadyUrl: '',
            templateId: 0,
            templateName: '',
            images: [
              {
                index: 0,
                projectId: '',
              },
            ],
          },
          sourceItemName: '',
          shippingId: 0,
          qty: 0,
          amounts: {
            unitPrice: 0,
            discount: 0,
            total: 0,
          },
        },
      ],
      transactions: [
        {
          type: '',
          processorId: 0,
          processorType: '',
          paymentMethod: '',
          processorTransactionId: '',
          processorResponse: '',
          dateTime: '',
          amount: 0,
          currency: 'USD',
          purchaseOrder: '',
          giftCardCode: '',
          processorCreditCardId: '',
          creditCardLast4: '',
          processorCustomerId: '',
          processorTransactionURL: '',
        },
      ],
      fulfillment: {
        boxes: [{
            items: [{
                sku: '',
                orderItemId: 0
              }],
            trackingNumber: ''
          }],
        source: '',
        orderNumber: ''
      },
      processing: {
        status: null,
        error: null,
        fulfillment: {
          status: null,
        },
        image: {
          status: null,
          images: [],
        },
        pdf: {
          status: null,
          pdfs: [],
        },
      },
    },
  ],
  order: {
    id: '',
    sourceId: '',
    salesChannelId: 0,
    cartId: '',
    dropship: true,
    createDate: '',
    status: '',
    discount: {
      promoCode: '',
      discountName: '',
      discountType: '',
    },
    customer: {
      id: '',
      sourceId: '',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
    },
    notes: {
      gift: '',
      public: '',
      private: '',
    },
    billingAddress: {
      address1: '',
      address2: '',
      city: '',
      state: '',
      zipCode: '',
      country: '',
    },
    shipping: [
      {
        id: 0,
        method: '',
        address: {
          name: '',
          address1: '',
          address2: '',
          city: '',
          state: '',
          zipCode: '',
          country: '',
          phone: '',
          isBusiness: false,
        },
      },
    ],
    amounts: {
      merchandise: 0,
      tax: 0,
      shipping: 0,
      handling: 0,
      discount: 0,
      total: 0,
      currency: 'USD',
    },
    items: [
      {
        id: 0,
        itemId: 0,
        sourceId: 0,
        fulfillmentSku: '',
        sku: '',
        photoPersonalization: {
          edits: {},
          personalized: true,
          projectId: '',
          printReadyUrl: '',
          templateId: 0,
          templateName: '',
          images: [
            {
              index: 0,
              projectId: '',
            },
          ],
        },
        sourceItemName: '',
        shippingId: 0,
        qty: 0,
        amounts: {
          unitPrice: 0,
          discount: 0,
          total: 0,
        },
      },
    ],
    transactions: [
      {
        type: '',
        processorId: 0,
        processorType: '',
        paymentMethod: '',
        processorTransactionId: '',
        processorResponse: '',
        dateTime: '',
        amount: 0,
        currency: 'USD',
        purchaseOrder: '',
        giftCardCode: '',
        processorCreditCardId: '',
        creditCardLast4: '',
        processorCustomerId: '',
        processorTransactionURL: '',
      },
    ],
    processing: {
      status: null,
      error: null,
      fulfillment: {
        status: null,
      },
      image: {
        status: null,
        images: [],
      },
      pdf: {
        status: null,
        pdfs: [],
      },
    },
  },
  fulfillment: {
    boxes: [{
        items: [{
            sku: '',
            orderItemId: 0
          }],
        trackingNumber: ''
      }],
    source: '',
    orderNumber: ''
  },
  meta: {
    count: 0,
    totalCount: 0,
    pageCount: 0,
    self: `${ROOT_URL}/orders?page=1`,
    previous: null,
    next: null,
    first: null,
    last: null,
    page: 0,
    limit: 20,
  },
};

function orders(state = initialState, action) {
  switch (action.type) {
    case types.ORDERS_FETCH_SUCCESS:
      // return assign({}, state, action.res);
      return assign({}, state, {
        results: action.res.results,
        meta: action.res.meta,
        draw: false,
      });
    case types.REPORTS_FETCH_SUCCESS:
        return assign({}, state, {
          report: action.res.results,
          meta: action.res.meta,
        });
    case types.ORDERS_FETCH_ERROR:
    case types.ORDER_FETCH_ERROR:
    case types.ORDER_EDIT_ERROR:
    case types.ORDER_SET_ERROR:
    case types.ORDER_DELETE_ERROR:
    case types.ORDER_DISABLE_ERROR:
    case types.ORDER_SHIPMENT_ERROR:
    case types.ORDER_FETCH_LAST60_ERROR:
    case types.ORDER_FULFILLMENT_SET_ERROR:
      return assign({}, state, {
        error: action.res,
        draw: false,
      });
    case types.ORDER_FETCH_LAST60_SUCCESS:
      console.log('last60->',action.res)
      return assign({}, state, {
        order: action.res.results,
        draw: false,
      });
    case types.ORDER_FETCH_SUCCESS:
    case types.ORDER_EDIT_SUCCESS:
    case types.ORDER_SET_SUCCESS:
    case types.ORDER_FULFILLMENT_SET_SUCCESS:
    case types.ORDER_DISABLE_SUCCESS:
      return assign({}, state, {
        order: action.res,
        draw: false,
      });
    case types.ORDER_DELETE_SUCCESS:
      return assign({}, state, {
        orderDelete: action.res.ok,
        draw: false,
      });
    case types.ORDERS_CLEAR_ERRORS:
      return assign({}, state, {
        error: null,
        draw: false,
      });
    default:
      return state;
  }
}

export default orders;



// WEBPACK FOOTER //
// ./src/reducers/orders.js